import { useQuery } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";

const queryKey = (id: string) => ["series-content", id];

const useSeriesContentQuery = (
  id: string,
  options?: {
    isEnabled?: boolean;
  },
) => {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey(id),
    queryFn: () => api.getSeriesContent(id),
    enabled: options?.isEnabled,
  });
};

export default useSeriesContentQuery;
